export default function Logo({ light = false, size = "md" }) {
  const h = size === "lg" ? "h-12 w-12" : "h-10 w-10";
  return (
    <span className="flex items-center gap-3">
      <img
        src="/images/kprc-logo.png"
        alt="KPRC — Kamana Physiotherapy & Rehab Center logo"
        className={`${h} ${h} shrink-0 rounded-full ring-1 ring-teal-brand/15`}
      />
      <span className="leading-none">
        <span
          className={`font-display text-lg sm:text-xl font-semibold tracking-tight block ${
            light ? "text-alabaster" : "text-teal-brand"
          }`}
        >
          Kamana Physiotherapy
        </span>
        <span
          className={`mono-label block mt-1 !text-[8.5px] ${
            light ? "text-gold" : "text-gold-deep"
          }`}
        >
          &amp; Rehab Center
        </span>
      </span>
    </span>
  );
}
